<template>

  <div id="page-user-list" class="vx-card p-6">
    <!-- Searchs-->
    <vx-card ref="filterCard" @keyup.enter="pressEnterSearch" id="user_list_filters" tabindex="0" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters"
             @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">開始日</label>
          <flat-pickr id="notification_start_date"
                      class="sm:mr-4 w-full sm:order-normal order-3 sm:mt-0 mt-4 flatpickr-style"
                      v-model="searchCondition.notification_start_date"
                      placeholder="開始日"
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">終了日</label>
          <flat-pickr id="notification_end_date"
                      class="sm:mr-4 w-full sm:order-normal order-3 sm:mt-0 mt-4 flatpickr-style"
                      v-model="searchCondition.notification_end_date"
                      placeholder="終了日"
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="タイトル"
                    v-model="searchCondition.title"
                    icon-after="true" :icon="searchCondition.title ? iconVsInput : ''" />
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full mt-8">
          <vs-checkbox
              v-model="searchCondition.deletedChecked"
          >削除済みも含む
          </vs-checkbox>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full mt-8">
          <vs-checkbox
              v-model="searchCondition.outOfPeriodChecked"
          >掲載期間外も含む
          </vs-checkbox>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
          <vs-button icon="search" @click="pageNumber = 1; searchNotificationForSys(); ids = []">
            検索
          </vs-button>
        </div>
      </div>
    </vx-card>
    <!-- Title and Button Action -->
    <div class="text-title">
      <span>お知らせ一覧</span>
    </div>
    <vs-row class="pl-2">
      <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
        <span class="pr-2">表示件数:</span>
        <div class="vx-col md:w-24 w-full">
          <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
      </vs-col>
      <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
        <vs-button :disabled="ids.length > 0 ? false:true" color="danger" icon="delete"
                   @click="activeDelete = true">削除
        </vs-button>
        <vs-button :disabled="ids.length > 0 ? false:true" color="primary" icon="visibility"
                   @click="activeReadAll = true">一括既読
        </vs-button>
        <vs-button color="success" icon="add_alert" @click="setUpCreate">登録</vs-button>
      </vs-col>
    </vs-row>

    <vs-popup id="dialogDelete" title="お知らせの削除確認" :active.sync="activeDelete" button-close-hidden>
      <div>
          <span>
            {{this.ids.length}}個のお知らせが削除されます。宜しいでしょうか？
          </span>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
        <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
      </div>
    </vs-popup>

    <vs-popup id="dialogReadAll" title="一括操作確認" :active.sync="activeReadAll" button-close-hidden>
      <div>
          <span>
            選択したお知らせを一括に既読しますか。
          </span>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button @click="confirmReadAll" icon="visibility" color="primary" class="mx-2">はい</vs-button>
        <vs-button @click="activeReadAll = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
      </div>
    </vs-popup>

    <!-- Create and Edit Dialog -->
    <vs-popup id="dialogUpdate" :title="titlePopup" :active.sync="activePopup" button-close-hidden>
      <div>
        <div>
          <vx-card
                   card-background="rgb(240, 238, 241)"
                   height="420px"
                   class="pb-2"
                   style="font-size: 12px">
            <div>
              <vs-row class="mb-1">
                <vs-col class="flex items-center" vs-w="3">
                  <span>タイトル<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-input
                        placeholder="タイトル"
                        v-model="title"
                        :readonly="submited === false"
                        v-validate.immediate="'required|max:255'"
                        name="notifyTitle"
                        data-vv-as="タイトル"
                        class="w-full mb-4"/>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="12">
                      <span v-show="checkSubmit == true" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("notifyTitle") | convertError }}</span>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row class="mt-1">
                <vs-col class="flex items-center" vs-w="3">
                  <span>詳細</span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-textarea
                        placeholder="詳細"
                        rowspan="20"
                        style="background-color: white"
                        :readonly="submited === false"
                        v-model="content"
                    ></vs-textarea>
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="flex items-center" vs-w="3">
                  <span>掲載期間</span>
                </vs-col>
                <vs-col vs-w="4">
                  <flat-pickr id="notification_start_date"
                              class="w-full flatpickr-style"
                              v-model="notification_start_date"
                              placeholder="開始日"
                              style="background-color: white"
                              :disabled="submited === false"
                              :config="configDate"
                              >
                  </flat-pickr>
                </vs-col>
                <vs-col vs-w="1" class="m-auto text-center">
                  <span>～</span>
                </vs-col>
                <vs-col vs-w="4">
                  <flat-pickr id="notification_end_date"
                              class="w-full flatpickr-style"
                              v-model="notification_end_date"
                              placeholder="終了日"
                              style="background-color: white"
                              :disabled="submited === false"
                              :config="configDate"
                              >
                  </flat-pickr>
                </vs-col>
              </vs-row>
              <vs-row class="mt-3">
                <vs-col vs-offset="3">
                  <span v-show="validationErrors.error == true" class="mb-2 text-danger font-size-info" style="display: block;">{{validationErrors.notification_end_date}}</span>
                </vs-col>
              </vs-row>
            </div>
          </vx-card>
        </div>
        <div style="display: flex; justify-content: flex-end" class="pt-4">
          <vs-button v-if="!id" @click="actionCreate" v-show="submited === true" :disabled="submited === false" icon="add_alert" color="success"
                     style="padding: 8px; margin-right: 5px;height: 37px">登録
          </vs-button>
          <vs-button v-else @click="actionUpdate" v-show="submited === true" :disabled="submited === false" icon="assignment" color="success"
                     style="padding: 8px; margin-right: 5px;height: 37px">更新
          </vs-button>
          <vs-button @click="activePopup = false" icon="cancel" color="lightgrey"
                     style="padding: 8px; margin-right: 5px;height: 37px">閉じる
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- AgGrid Table -->
    <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="notificationForSysData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :rowClassRules="rowClassRules"
        :detailRowAutoHeight="true"
    >
    </ag-grid-vue>

    <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
        </div>
      </div>
      <!-- pagination -->
      <vs-pagination
          :total="totalPages"
          v-model="currentPage"
          :max="0"
          class="pr-10 pt-10"
      />
    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import {AgGridVue} from 'ag-grid-vue'
import vSelect from 'vue-select'
import EventBus from '../EventBus'
import {mapActions, mapGetters} from 'vuex'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {Japanese} from "flatpickr/dist/l10n/ja.js";
import {setupIconClickEvent} from "@/utils/helpler-utils";
// Cell Renderer
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    // Cell Renderer
    CellRendererActions
  },
  data() {
    return {
      iconVsInput: 'close', 
      Valid_Read_Status:1,
      titlePopup:'',
      activePopup: false,
      activeDelete: false,
      activeReadAll: false,
      submited: false,
      checkSubmit:false,
      title: '',
      content: '',
      notification_start_date: '',
      notification_end_date: '',
      id: null,
      ids: [],
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
      },
      searchCondition: {
        title: '',
        content: '',
        notification_start_date: '',
        notification_end_date: '',
        deletedChecked: '',
        outOfPeriodChecked: '',
      },
      validationErrors: {
        notification_end_date: '',
        error: false,
      },
      paginationOptions: [
        10, 20, 30, 50
      ],

      //SortServer
      orderBy: 'id',
      orderDir: 'desc',

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,
      rowClassRules: null,
      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 150,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          sort: 'desc',
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '投稿日時',
          field: 'created_at',
          width: 250,
          filter: true,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '更新日時',
          field: 'updated_at',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'タイトル',
          field: 'title',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '掲載期間',
          field: 'postPeriod',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },

        {
          headerName: '投稿者',
          field: 'created_by',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '更新者',
          field: 'updated_by',
          filter: true,
          width: 250,
          suppressMovable: true,
        },
        {
          headerName: '',
          field: 'transactions',
          width: 150,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            showDetail: true,
          },
          unSortIcon: false,
          suppressMovable: true,
        }
      ],
      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  watch: {
    paginationPageSize(val) {
      this.setPagination(val);
    },
    activePopup(val){
      if (val == true){
        this.validationErrors.error = false;
        this.validationErrors.notification_end_date = '';
        this.checkSubmit = false;
      }
    }
  },
  computed: {
    validateForm(){
      return !this.errors.any()
    },
    notificationForSysData() {
      /*let notificationForSysData = []
      this.$store.state.notificationForSys.notificationsForSys.forEach((element) => {
        notificationForSysData.push(Object.assign(element));
      });*/
      return this.$store.state.notificationForSys.notificationsForSys;
    },
    totalPages() {
      return parseInt(this.$store.state.notificationForSys.infoDB.totalPage)
    },
    totalRow() {
      return parseInt(this.$store.state.notificationForSys.infoDB.totalRow)
    },
    currentPage: {
      get() {
        return this.pageNumber
      },
      async set(val) {
        this.pageNumber = val
        await this.searchNotificationForSys();
        this.ids = []
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    ...mapActions({
      createNotificationForSys: 'notificationForSys/createNotificationForSys',
      updateNotificationForSys: 'notificationForSys/updateNotificationForSys',
      getNotificationForSys: 'notificationForSys/getNotificationForSys',
      searchNotificationsForSys: 'notificationForSys/searchNotificationsForSys',
      deleteNotificationForSys: 'notificationForSys/deleteNotificationForSys',
      deleteAllSelectNotificationsForSys: 'notificationForSys/deleteAllSelectNotificationsForSys',
      createReadNotificationsForSys: 'notificationForSys/createReadNotificationsForSys',
      getUnreadNotificationForSys: 'notificationForSys/getUnreadNotificationForSys',
      readAllSelectNotificationsForSys: 'notificationForSys/readAllSelectNotificationsForSys',
    }),
    clearInput() {
      this.searchCondition.title = ""; // Clear the value input
    },
    pressEnterSearch() {
      this.pageNumber = 1;
      this.searchNotificationForSys();
      this.ids = []
    },
    clearFocusTypeDropdown() {
      this.$nextTick(() => {
        document.activeElement.blur()
        document.getElementById('user_list_filters').focus()
      })
    },
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map(notificationForSys => notificationForSys.id)
    },
    onSortChangedEvent(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        if (column.getSort()) {
          root.orderDir = column.getSort()
          root.orderBy = column.getColId()
          root.searchNotificationForSys();
          return;
        }
      });
    },
    searchNotificationForSys() {
      this.searchNotificationsForSys({
        title: this.searchCondition.title,
        notification_start_date: this.searchCondition.notification_start_date,
        notification_end_date: this.searchCondition.notification_end_date,
        contain_deleted: this.searchCondition.deletedChecked ? 1 : 0,
        contain_out_of_period: this.searchCondition.outOfPeriodChecked ? 1 : 0,
        orderBy: this.orderBy,
        orderDir: this.orderDir,
        limit: this.paginationPageSize,
        page: this.pageNumber
      })
    },
    setUpCreate() {
      // clear all fields before create
      this.titlePopup ='お知らせの登録'
      this.submited = false
      this.id = ''
      this.title = ''
      this.content = ''
      this.notification_start_date = ''
      this.notification_end_date = ''
      this.activePopup = true
      this.submited = true
    },
    async actionCreate() {
      this.checkSubmit = true;

      let notificationForSys = {
        title: this.title,
        content: this.content,
        notification_start_date: this.notification_start_date,
        notification_end_date: this.notification_end_date,
      }
      if (notificationForSys.notification_end_date < notificationForSys.notification_start_date){
        this.activePopup = true;
        this.validationErrors.error = true;
        this.validationErrors.notification_end_date = "掲載終了日は掲載開始日より後ろの日付に設定してください";
      }else if(!this.validateForm){
        this.activePopup = true;
      }else {
        await this.createNotificationForSys(notificationForSys)
        this.getUnreadNotificationForSys()
        this.activePopup = false
        this.validationErrors.error = false;
        this.validationErrors.notification_end_date = '';
        await this.searchNotificationForSys()
      }
    },
    async actionUpdate() {
      this.checkSubmit = true;
      if (this.notification_end_date < this.notification_start_date){
        this.activePopup = true;
        this.validationErrors.error = true;
        this.validationErrors.notification_end_date = "掲載終了日は掲載開始日より後ろの日付に設定してください";
      }else if(!this.validateForm){
        this.activePopup = true;
      }else {
      await this.updateNotificationForSys(
          {
            id: this.id,
            title: this.title,
            content: this.content,
            notification_start_date: this.notification_start_date,
            notification_end_date: this.notification_end_date,
          })
      this.activePopup = false
      this.validationErrors.error = false;
      this.validationErrors.notification_end_date = '';
      this.ids = []
      await this.searchNotificationForSys()
      }
    },
    async confirmDelete() {
      await this.deleteSelect();
      this.activeDelete = false
      this.activePopup = false
    },
    async confirmReadAll() {
      await this.readAllSelect();
      this.activeReadAll = false
      this.activePopup = false
    },
    async deleteSelect() {
      await this.deleteAllSelectNotificationsForSys(this.ids)
      this.gridApi.deselectAll()
      this.ids = null
      this.getUnreadNotificationForSys()
      await this.searchNotificationForSys()
    },
    async readAllSelect() {
      let ids = []
      this.ids.forEach(item=>{
        this.$store.state.notificationForSys.notificationsForSys.map((element) => {
          if (element.id == item && element.read_status == 0){
            ids.push(element.id)
          }
        });
      })
      await this.readAllSelectNotificationsForSys(ids)
      this.gridApi.deselectAll()
      this.ids = null
      this.getUnreadNotificationForSys()
      await this.searchNotificationForSys()
    },
    async setPagination(val) {
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      await this.searchNotificationForSys();
      this.ids = []
    },
    async resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.searchCondition.title = ''
      this.searchCondition.content = ''
      this.searchCondition.notification_start_date = ''
      this.searchCondition.notification_end_date = ''
      this.searchCondition.deletedChecked = ''
      this.searchCondition.outOfPeriodChecked = ''
      this.ids = []
      await this.searchNotificationForSys()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    editListener(id) {
      this.titlePopup ='お知らせの更新'
      this.getNotificationForSys(id)
          .then(async notificationForSys => {
            this.id = notificationForSys.id
            this.title = notificationForSys.title
            this.content = notificationForSys.content
            this.notification_start_date = notificationForSys.notification_start_date
            this.notification_end_date = notificationForSys.notification_end_date
            this.submited = true
            this.activePopup = true
            notificationForSys.read_status = this.Valid_Read_Status
            this.$store.commit('notificationForSys/UPDATE_READ_NOTIFICATIONS_FOR_SYS',notificationForSys.id);
            await this.createReadNotificationsForSys({
              notification_for_sys_id: notificationForSys.id,
              read_status: 1,
            })
            this.gridApi.redrawRows()
            this.getUnreadNotificationForSys()
          })
    },
    deleteListener() {
      this.activeDelete = true
    },
    showListener(id) {
      this.titlePopup ='お知らせの詳細'
      this.getNotificationForSys(id)
          .then(async item => {
            this.id = item.id
            this.title = item.title
            this.content = item.content
            this.notification_start_date = item.notification_start_date
            this.notification_end_date = item.notification_end_date
            this.activePopup = true
            this.submited = false
            item.read_status = this.Valid_Read_Status
            this.$store.commit('notificationForSys/UPDATE_READ_NOTIFICATIONS_FOR_SYS',item.id);
            await this.createReadNotificationsForSys({
              notification_for_sys_id: item.id,
              read_status: 1,
            })
            this.gridApi.redrawRows()
            this.getUnreadNotificationForSys()
          })
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
    EventBus.$on('editRecord', this.editListener)
    EventBus.$on('deleteRecord', this.deleteListener);
    EventBus.$on('showRecord', this.showListener)
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function () {
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    });

    this.rowClassRules = {
      'unreadBold': (params) => {
        var readStatus = params.data.read_status;
        return readStatus == 0;
      },
      'readed': (params) => {
        var readStatus = params.data.read_status;
        return readStatus == 1;
      },
    };
    setupIconClickEvent();
  },
  async created() {
    await this.searchNotificationForSys();
    this.getUnreadNotificationForSys();
    },
  beforeMount() {
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  updated() {
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10)
    // calc number startRow and endRow
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.notificationForSysData.length > 0) {
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if (this.notificationForSysData.length == this.paginationPageSize) this.endRow = this.pageNumber * this.paginationPageSize
        else this.endRow = this.paginationPageSize * this.pageNumber + this.notificationForSysData.length - this.paginationPageSize
      }
      if (this.notificationForSysData.length == 0) {
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('editRecord', this.editListener);
    EventBus.$off('deleteRecord', this.deleteListener);
    EventBus.$off('showRecord', this.showListener);
  },
  destroyed() {
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogDelete').style.display = 'none'
    document.getElementById('dialogReadAll').style.display = 'none'
    document.getElementById('dialogUpdate').style.display = 'none'
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/kinds.scss"
</style>
<style>
.unreadBold {
  font-weight: bold;
}
.readed {
  font-weight: unset;
}
.vs-con-input .icon-after {
  right: 7px;
  top: 10px;
  border: none;
  cursor: pointer;
}
</style>
